<template>
	<div class="AIautoReplyConfig">
		<el-row class="config" type="flex">
			<el-col :span="24" class="set">
				<client-module moduletitle="AI自动回复">
					<span slot="customHint" class="hint"
						>基于您网站资料并结合AI模型技术，为采购商提供智能、精准的自动回复服务，提升沟通效率与客户体验</span
					>
					<div class="switch_body" v-loading="switchLoding">
						<div class="switch_title">自动回复</div>
						<div class="content">
							<el-switch
								:active-value="1"
								:inactive-value="0"
								v-model="configData.autoReply"
								@change="setAIReplyConfig('switchLoding')"
							></el-switch>
							<span
								>开启后，AI将24小时在线，无论您是否在线，均可在采购商发送消息后自动回复，提升采购商体验，助力成交转化。</span
							>
							<span class="tips"
								>*请注意：AI生成的内容可能存在不准确之处，建议定期核实发送信息，如有问题，可与您的顾问反馈。</span
							>
						</div>
					</div>
				</client-module>
			</el-col>
		</el-row>

		<el-row class="config" type="flex">
			<el-col :span="24" class="set">
				<client-module moduletitle="托管设置">
					<div class="hosting_body" v-loading="radioLoding">
						<el-radio-group
							v-model="configData.hostingType"
							@input="setAIReplyConfig('radioLoding')"
						>
							<el-radio :label="item.value" border v-for="item in hostingList">
								<div class="item_body">
									<div class="name">{{ item.name }}</div>
									<div class="text">{{ item.text }}</div>
								</div>
								<div class="corner-label" v-if="item.isHit">推 荐</div>
								<div class="checkmark" v-if="configData.hostingType === item.value">
									<i class="el-icon-check icon"></i>
								</div>
							</el-radio>
						</el-radio-group>
					</div>
				</client-module>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule.vue';

import chat from '@/backend/services/account/chat.js';

export default {
	name: 'AIautoReplyConfig',
	components: {
		clientModule,
	},
	data() {
		return {
			configData: { autoReply: 0, hostingType: 0 },
			switchLoding: false,
			radioLoding: false,
			hostingList: [
				{
					name: 'AI托管',
					value: 0,
					text: '当人工客服在线时，让AI托管即时回复对话，您也可以随时人工接管。',
					isHit: true,
				},
				{
					name: '完全人工',
					value: 1,
					text: '当人工客服在线时，可以选择直接接管所有对话，跳过AI回复，确保用户得到最直接的服务。',
				},
			],
		};
	},
	computed: {
		getserviceId: function () {
			let serviceId = this.$route.query.serviceSiteId;
			return serviceId;
		},
	},
	mounted() {
		this.requestData();
	},
	methods: {
		//加载数据
		async requestData() {
			this.getAIReplyConfig();
		},
		// 获取AI自动回复配置
		async getAIReplyConfig() {
			let { getserviceId: serviceSiteId } = this;
			let res = await chat.getAIReplyConfig({ serviceSiteId });
			if (res && res.data) {
				this.configData = res.data;
			}
		},
		async setAIReplyConfig(type) {
			this[type] = true;

			let { configData, getserviceId: serviceSiteId } = this;

			let res = await chat.setAIReplyConfig({
				...configData,
				serviceSiteId,
			});
			if (res) {
				this[type] = false;
				this.$message({
					showClose: true,
					message: '修改成功',
					type: 'success',
				});
				this.requestData();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.AIautoReplyConfig {
	.config {
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		background-color: #fff;
		margin: 20px 0;
	}

	.hint {
		margin-left: 10px;
		color: #999;
		font-size: 12px;
		font-weight: normal;
	}

	.switch_body {
		display: flex;
		padding: 10px 40px;
		height: 120px;

		.switch_title {
			font-size: 15px;
			color: #333;
			font-weight: bold;
			margin-right: 10px;
		}
		.content {
			display: flex;
			flex-direction: column;

			.el-switch {
				width: 40px;
			}

			span {
				margin-top: 10px;
				font-size: 13px;
			}

			.tips {
				color: #ff4949;
			}
		}
	}

	.hosting_body {
		.el-radio-group {
			width: 100%;
			display: grid;
			padding: 20px 30px;
			grid-template-columns: repeat(2, 1fr);
			grid-column-gap: 30px;

			::v-deep .el-radio {
				position: relative;
				padding: 10px 20px;
				margin: 0px;
				height: 100px;
				padding: 16px;
				background-color: white;
				box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
				overflow: hidden;

				.el-radio__input {
					display: none;
				}

				.el-radio__label {
					padding: 0px;
					display: block;
					height: 100%;

					.item_body {
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.name {
							font-size: 16px;
							color: #333;
							font-weight: bold;
						}

						.text {
							color: #333;
						}
					}

					.corner-label {
						position: absolute;
						top: -10px;
						right: -25px;
						background-color: #1e90ff;
						color: white;
						font-size: 12px;
						padding: 20px 20px 5px;
						border-radius: 4px;
						transform: rotate(45deg);
						box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
					}

					.checkmark {
						position: absolute;
						bottom: -17px;
						right: -28px;
						background-color: #1e90ff;
						color: white;
						padding: 3px 25px 22px;
						border-radius: 4px;
						transform: rotate(-45deg);
						box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

						.icon {
							transform: rotate(45deg);
							font-size: 20px;
						}
					}
				}
			}
		}
	}
}
</style>
